import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

const AsideNavOutsideAlerter = styled.div`
  width: '0px';
`;

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, onClickOutside) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target) && window.innerWidth < 769) {
        onClickOutside();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClickOutside, ref]);
}

/**
 * Component that alerts if you click outside of it
 */
export default function NavOutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.onClickOutside);

  return (
    <AsideNavOutsideAlerter ref={wrapperRef}>
      {props.children}
    </AsideNavOutsideAlerter>
  );
}
